<template>
  <div style="background-color: #F5F7FA;height: 100%;">
    <div style="padding: 20px;">

        <template>
          <el-col :span="24">
            <el-col :span="20" style="padding:5px 5px; " >
              <Daterange :startTime="startTime"  is-datetime="datetime" :endTime="endTime" @dataChange='dataChange'></Daterange>
            </el-col>
            <el-col :span="4" style="padding:5px 0px; "  >
              <el-button style="float: right;" size="mini" type="primary" @click="submit">搜索</el-button>
            </el-col>
          </el-col>

          <el-table v-loading="tableLoading"  :data="tableData" :height="300" border style=" max-height: 500px ;overflow-y: auto;overflow-x: auto ">
            <el-table-column prop="alarmType  " :formatter="getAlarmType" label="报警类型" ></el-table-column>
            <el-table-column prop="sendDateTime" :formatter="getSendDateTime" label="报警时间" ></el-table-column>
          </el-table>
          <div style="text-align: left;background-color: #fff;padding: 10px;">
            <div style="float: left;padding: 5px;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
            <div style="float: left;">
              <el-pagination
                  background
                  layout="prev, pager, next"
                  :total="totalItems"
                  :page-size="20"
                  :current-page.sync="currentPage"  @current-change="current_change">
              </el-pagination>
            </div>
            <div style="clear: both;"></div>
          </div>
        </template>
  </div>
  </div>
</template>

<script>


import {timefilters, timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getStaffCode} from "@/utils/auth";
import Daterange from "@/components/Daterange";

export default {
  name: "SleepQualityPage",
  data() {
    return {
      tableLoading:false,
      userCode: '',
      pageIndex:'',
      tableData:null,
      totalItems: 0,
      pageSize:20,
      currentPage:1,
      startTime:'',
      endTime:''
    }
  },
  components: {
    Daterange
  },

  methods: {
    init(userCode) {
      this.userCode = userCode;
      this.endTime=timefilters(new Date())
      this.startTime=timefilters(new Date(new Date()-1000 * 60 * 60 * 24 * 7))
      this.getSleepAlarm();
    },
    dataChange(val){
      this.startTime=val[0]
      this.endTime=val[1]
    },
    closeSelf() {
      this.$emit("closeSleepAlarm");
    },
    current_change:function(currentPage){
      this.currentPage = currentPage;
      this.getSleepAlarm();
    },
    submit(){
      this.getSleepAlarm();
    },
    getAlarmType(row){
      if(row.alarmType==='breath'){
        return '呼吸率异常';
      }
      if(row.alarmType==='heartrate'){
        return '心率异常';
      }
      if(row.alarmType==='bodymove'){
        return '体动次数多于设置值';
      }
      if(row.alarmType==='outbedtimecount'){
        return '累计离床时间多于设置值';
      }
      if(row.alarmType==='outbedtimeonce'){
        return '单次离床时间多于设置值';
      }
      if(row.alarmType==='outbednumber'){
        return '离床次数多于设置值';
      }
      if(row.alarmType==='onbed'){
        return '上床时间过晚';
      }
      if(row.alarmType==='sleeplimitend'){
        return '起床过晚';
      }
      if(row.alarmType==='sleeplimitstart'){
        return '入睡过晚';
      }
    },
    getSendDateTime(row){
      return timefilters(row.sendDateTime);
    },

    getSleepAlarm(){
      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$deviceUrl + "SBJ/GetSleepAlarm",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          userCode: this.userCode,
          startTime:this.startTime,
          endTime:this.endTime,
          pageIndex:this.currentPage,
          pageSize:this.pageSize,
        }
      }).then(
          (response) => {
            this.tableLoading=false
            if (response.data.error === 0) {
              this.tableData=response.data.data.list;
              this.totalItems=response.data.data.total;
            } else if (response.data.error === 1) {
              this.$message.error(response.data.message)
            }
          }
      )

    },




  }


}
</script>

<style lang="scss" scoped>
</style>
